export default __webpack_public_path__ + "static/media/new2.12ad1ec9.jpeg";